import { ReportSubscription } from "@/model/data/reportSubscription/ReportSubscription";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { GetReportSubscriptionResData } from "./GetReportSubscriptionResData";

const ENDPOINT = "/report_subscription/rs";

export class SetReportSubscriptionsCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    reportSubscriptions: ReportSubscription[];
    fromPlatformMaintenance: boolean;

    constructor(reportSubscriptions: ReportSubscription[], fromPlatfromMaintenance = false) {
        super();
        this.reportSubscriptions = reportSubscriptions;
        this.fromPlatformMaintenance = fromPlatfromMaintenance;
    }

    public async execute(): Promise<GetReportSubscriptionResData> {
        let res = await this.executeCommand({ ReportSubscriptions: this.reportSubscriptions, FromPlatformMaintenance: this.fromPlatformMaintenance });
        return new GetReportSubscriptionResData(res);
    }
}
